import { jsx, jsxs } from "react/jsx-runtime";
import { Button, Select } from "@pcln/horizon";
import { useMemo, useState } from "react";
import { createDateOptions, cruiseLineOptions, currentMonth, durationOptions, locationOptions } from "./constants.js";
import { getGridContainerClass, getInputClass, getSubmitButtonClass } from "./CruiseSearchForm.variants.js";
const createOption = (option)=>({
        label: option.label,
        value: option.value,
        disabled: option.disabled || false
    });
function CruiseSearchForm({ onSubmit, isMobile = false, initialValues }) {
    const [location, setLocation] = useState(initialValues?.location ?? '');
    const [cruiseLine, setCruiseLine] = useState(initialValues?.cruiseLine ?? '');
    const [startDate, setStartDate] = useState(initialValues?.startDate ?? currentMonth);
    const [duration, setDuration] = useState(initialValues?.duration ?? '');
    const locations = useMemo(()=>locationOptions.map(createOption), []);
    const cruiseLines = useMemo(()=>cruiseLineOptions.map(createOption), []);
    const dateOptions = useMemo(()=>createDateOptions(new Date()).map(createOption), []);
    const durations = useMemo(()=>durationOptions.map(createOption), []);
    const handleSubmit = (e)=>{
        e.preventDefault();
        onSubmit({
            location,
            cruiseLine,
            startDate,
            duration
        });
    };
    return /*#__PURE__*/ jsx("div", {
        className: "@container w-auto",
        children: /*#__PURE__*/ jsx("form", {
            onSubmit: handleSubmit,
            "aria-label": "cruise search",
            children: /*#__PURE__*/ jsxs("div", {
                className: getGridContainerClass(),
                children: [
                    /*#__PURE__*/ jsx(Select, {
                        label: "Destination",
                        isInset: true,
                        iconLeft: "search",
                        menuItems: locations,
                        value: location,
                        onChange: setLocation,
                        placeholder: "Destination",
                        initialValue: "Destination",
                        className: getInputClass('destination')
                    }),
                    /*#__PURE__*/ jsx(Select, {
                        label: "Departing",
                        iconLeft: "calendar_month",
                        isInset: true,
                        menuItems: dateOptions,
                        value: startDate,
                        onChange: setStartDate,
                        placeholder: "Select date",
                        className: getInputClass('departure')
                    }),
                    /*#__PURE__*/ jsx(Select, {
                        iconLeft: "calendar_clock",
                        label: "Cruise Length",
                        isInset: true,
                        menuItems: durations,
                        value: duration,
                        onChange: setDuration,
                        placeholder: "Any length",
                        className: getInputClass('length')
                    }),
                    /*#__PURE__*/ jsx(Select, {
                        iconLeft: "directions_boat",
                        label: "Cruise Line",
                        isInset: true,
                        menuItems: cruiseLines,
                        value: cruiseLine,
                        onChange: setCruiseLine,
                        placeholder: "All cruise lines",
                        className: getInputClass('line')
                    }),
                    /*#__PURE__*/ jsx(Button, {
                        buttonType: "submit",
                        type: "primary",
                        size: "lg",
                        className: getSubmitButtonClass(isMobile),
                        children: "Book Now"
                    })
                ]
            })
        })
    });
}
export { CruiseSearchForm };
